import { StreetModes, customerAddressFormConfig } from 'constants/index';
import { zipCodeValidation } from 'utils/form';

const comboBoxWithInputFields = ['buildingNumber', 'zipCode'];

const validate = (values, props = {}) => {
	const errors = {};
	const isRegistrationAddress = props.addressType === 'registration';
	const hasAddressInput = customerAddressFormConfig.some(field => Boolean(values[field.name] || values[`${field.name}Input`]));
	const hasManualStreetInput = Boolean(values.streetName || values.streetType);
	const shouldValidateRequiredFields = !isRegistrationAddress
		|| Boolean(values.isSameAsPhysical)
		|| hasAddressInput
		|| hasManualStreetInput;

	// without "addressType"
	customerAddressFormConfig.forEach(field => {
		if (shouldValidateRequiredFields && field.required && !values[field.name]) {
			errors[field.name] = 'Обов\'язкове поле';
		}

		if (values.mode === StreetModes.MANUAL && shouldValidateRequiredFields) {
			errors.street = undefined;

			if (!values.streetName) {
				errors.streetName = 'Обов\'язкове поле';
			} else if (field.name === 'street' && values.streetName.length > field.inputProps.maxLength) {
				errors.streetName = `Занадто велика назва(${field.inputProps.maxLength} максимальна кількість символів)`;
			}

			if (!values.streetType) {
				errors.streetType = 'Обов\'язкове поле';
			}
		}
	});

	comboBoxWithInputFields.forEach(field => {
		if (errors[field] && values[`${field}Input`]) {
			errors[field] = undefined;
		}
	});

	if (values.zipCodeInput && zipCodeValidation(values.zipCodeInput)) {
		errors.zipCode = zipCodeValidation(values.zipCodeInput);
	}

	return errors;
};

export default validate;
